import clsx from "clsx";
import { useState } from "react";

type SearchBarProps = {
    value: string;
    placeholder: string;
    additionalSearchElements?: React.ReactNode;
    onChange: (value: string) => void;
};

const SearchBar = ({
    value,
    placeholder,
    additionalSearchElements,
    onChange,
}: SearchBarProps) => {
    const [focused, setFocused] = useState(false);

    return (
        <div
            className={clsx(
                "rounded-full flex items-center h-[2.875rem] bg-surface-light-2 px-5",
                focused && "outline outline-2 outline-soft-green-80"
            )}
        >
            <input
                type="text"
                placeholder={placeholder}
                className="bg-transparent text-surface-dark-1 outline-none flex-1 pr-4 min-w-[5rem]"
                value={value}
                onChange={(e) => onChange(e.currentTarget.value)}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            />
            <div className="ml-auto flex items-center gap-5">
                {additionalSearchElements}
            </div>
        </div>
    );
};

export default SearchBar;
